import { defineStore } from 'pinia'
import { useRequest } from 'composables/useRequest.js'

export const useAdminBugsStore = defineStore('adminBugs', {
  state: () => ({
    records: [],
    page: { total_pages: 1, total_records: 0, current_page: 1 },
    loading: false,
    error: null,
    currentPage: 1,
    statusFilter: '',
  }),

  actions: {
    async fetchData() {
      this.loading = true
      this.error = null
      try {
        const { axiosRequest } = useRequest()
        const params = {
          page: { number: this.currentPage, limit: 20 },
          sort_by: 'created_at',
          sort_order: 'DESC',
        }
        if (this.statusFilter) params.status = this.statusFilter
        const res = await axiosRequest('GET', '/api/v1/admin/trouble_shoots', params, false)
        if (!res.js_error && res.response.success) {
          this.records = res.response.data.records
          this.page = res.response.data.page
        } else {
          this.error = 'Failed to load bug reports.'
        }
      } catch {
        this.error = 'Something went wrong.'
      } finally {
        this.loading = false
      }
    },

    async updateRecord(id, payload) {
      const { axiosRequest } = useRequest()
      const res = await axiosRequest('PUT', `/api/v1/admin/trouble_shoots/${id}`, { trouble_shoot: payload }, false)
      if (!res.js_error && res.response.success) {
        const idx = this.records.findIndex(r => r.id === id)
        if (idx !== -1) this.records[idx] = res.response.data.record
      }
      return res
    },

    setPage(n) {
      this.currentPage = n
      this.fetchData()
    },

    setStatusFilter(s) {
      this.statusFilter = s
      this.currentPage = 1
      this.fetchData()
    },
  },
})
